import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  GenerativeAINeural,
  GenerativeAICustom,
  GenerativeAIContent,
  GenerativeAIUser,
  GenerativeAIEnd,
  GenerativeAITime,
  GenerativeAIAPI,
  GenerativeAIScalable,
} from "../../../app-constants";

function Generativeaipartner() {
  return (
    <section className="generative_ai_partner p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Partner with TekRevol to Gain <span>GenAI Excellence</span>
            </h2>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="generative_ai_box">
              <div className="generative_ai_svg">{GenerativeAINeural}</div>
              <div className="generative_ai_content">
                <h5>
                  Specialized Neural
                  <br /> Networks
                </h5>
                <p>
                  Our experts deploy advanced neural networks, optimizing your
                  business operations with precision and efficiency.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="generative_ai_box">
              <div className="generative_ai_svg">{GenerativeAICustom}</div>
              <div className="generative_ai_content">
                <h5>
                  Custom Generative <br /> Models
                </h5>
                <p>
                  We develop custom generative models tailored to your data,
                  enhancing predictive accuracy and decision-making.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="generative_ai_box">
              <div className="generative_ai_svg">{GenerativeAIContent}</div>
              <div className="generative_ai_content">
                <h5>
                  Automated Content <br /> Generation
                </h5>
                <p>
                  Utilize AI-driven content creation for scalable, high-quality
                  outputs across various media and platforms.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="generative_ai_box">
              <div className="generative_ai_svg">{GenerativeAIUser}</div>
              <div className="generative_ai_content">
                <h5>
                  Adaptive User <br /> Interfaces
                </h5>
                <p>
                  Experience dynamic user interfaces powered by machine
                  learning, improving user interaction and engagement.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="generative_ai_box">
              <div className="generative_ai_svg">{GenerativeAIEnd}</div>
              <div className="generative_ai_content">
                <h5>
                  End-to-End <br /> Encryption
                </h5>
                <p>
                  Implement comprehensive end-to-end encryption, safeguarding
                  sensitive data with industry-leading security protocols.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="generative_ai_box">
              <div className="generative_ai_svg">{GenerativeAITime}</div>
              <div className="generative_ai_content">
                <h5>
                  Real-Time <br /> Analytics
                </h5>
                <p>
                  Benefit from real-time data analytics and insights, driving
                  informed business strategies and operations.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="generative_ai_box">
              <div className="generative_ai_svg">{GenerativeAIAPI}</div>
              <div className="generative_ai_content">
                <h5>
                  API <br /> Integrations
                </h5>
                <p>
                  Seamlessly integrate GenAI capabilities with existing systems
                  through robust API integrations, enhancing functionality.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="generative_ai_box">
              <div className="generative_ai_svg">{GenerativeAIScalable}</div>
              <div className="generative_ai_content">
                <h5>
                  Scalable <br />
                  cloud solutions
                </h5>
                <p>
                  Our scalable cloud infrastructure supports growing data
                  demands, ensuring seamless expansion and performance.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Generativeaipartner;
